export class HrmEmployeeFamilyDetailsDto {
    
    employeeFamilyId: number;
    familyMemName: string;
    relation: string;
    famDateOfBirth: Date;
    famAadharNo: number;
    isActive: boolean;
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number;
}
